<template>
  <div>
    <DjHeader />
    <div class="relative z-0">
      <slot />
    </div>
    <DjFooter />
  </div>
</template>

<script lang="ts" setup>
  defineOptions({
    name: 'Default',
  });
</script>
